import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

function Navlinks(props) {
  const animationFrom = { opacity: 0, y: -40 };
  const animationTo = { opacity: 1, y: 0 };
  return (
    <ul>
      <motion.li
        initial={animationFrom}
        animate={animationTo}
        transition={{ delay: 0.05 }}
      >
        <Link
          to="home"
          smooth={true}
          duration={1000}
          onClick={() => props.isMobile && props.closeMobileMenu()}
        >
          Home
        </Link>
      </motion.li>
      <motion.li
        initial={animationFrom}
        animate={animationTo}
        transition={{ delay: 0.1 }}
      >
        <Link
          to="about"
          smooth={true}
          duration={1000}
          onClick={() => props.isMobile && props.closeMobileMenu()}
        >
          About Me
        </Link>
      </motion.li>
      <motion.li
        initial={animationFrom}
        animate={animationTo}
        transition={{ delay: 0.15 }}
      >
        <Link
          to="skills"
          smooth={true}
          duration={1000}
          onClick={() => props.isMobile && props.closeMobileMenu()}
        >
          Skills
        </Link>
      </motion.li>
      <motion.li
        initial={animationFrom}
        animate={animationTo}
        transition={{ delay: 0.2 }}
      >
        <Link
          to="projects"
          smooth={true}
          duration={1000}
          onClick={() => props.isMobile && props.closeMobileMenu()}
        >
          Projects
        </Link>
      </motion.li>
      <motion.li
        initial={animationFrom}
        animate={animationTo}
        transition={{ delay: 0.25 }}
      >
        <Link
          to="contact"
          smooth={true}
          duration={1000}
          onClick={() => props.isMobile && props.closeMobileMenu()}
        >
          Contact
        </Link>
      </motion.li>
    </ul>
  );
}

export default Navlinks;
